
const PaymentStatus = {
  statusClass(status) {
    const map = {
      paid: 'badge-success',
      ok: 'badge-success',
      fail: 'badge-danger',
      more: 'badge-warning',
      pending: 'badge-warning',
      refund: 'badge-warning',
      dispute: 'badge-danger'
    }
    return 'badge ' + map[status]
  }
}

export default PaymentStatus